/**
 * 10.9L20 — "NOVA VOLTA" (aparece por cima do Mapa quando a Profundidade sobe). Thiago: "poderia
 * por pra a cada nivel sair aparecendo no mapa e explicando o que vai ser liberado". Explica em
 * uma tela só o que muda na volta nova (territórios/baús resetam, portas pedem mais nível, pontos
 * da Árvore) — antes só saíam 2 banners rápidos, fáceis de não ler.
 */
import { i18n } from "../i18n/i18n";

export class DepthIntro {
  private readonly root: HTMLDivElement;

  constructor(uiRoot: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "overlay upd-overlay";
    this.root.hidden = true;
    uiRoot.appendChild(this.root);
  }

  get isOpen(): boolean { return !this.root.hidden; }

  open(depth: number, treePoints: number, onClose: () => void): void {
    const esc = (s: string): string => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const items = [
      i18n.t("depth.intro.territories"),
      i18n.t("depth.intro.chests"),
      i18n.t("depth.intro.harder"),
      i18n.t("depth.intro.tree", { n: String(treePoints) }),
    ];
    this.root.innerHTML = `
      <div class="panel void-panel upd-panel">
        <h2 class="upd-h">🌌 ${esc(i18n.t("depth.intro.title", { n: String(depth) }))}</h2>
        <div class="upd-body">
          <div class="upd-entry">
            <ul class="upd-list">${items.map((it) => `<li>${esc(it)}</li>`).join("")}</ul>
          </div>
        </div>
        <button class="btn primary upd-claim">${esc(i18n.t("update.ok"))}</button>
      </div>`;
    this.root.hidden = false;
    this.root.querySelector<HTMLButtonElement>(".upd-claim")!.addEventListener("click", () => {
      this.root.hidden = true;
      onClose();
    }, { once: true });
  }
}
